var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import { Icon } from '@gerdau/hefesto';
import './Menu.styles.scss';
import { EMappepMenuEventCodes } from './Menu.utils';
import { DropdownMenu } from './DropdownMenu';
var Menu = function (_a) {
    var menuOptions = _a.menuOptions;
    return (_jsx("nav", __assign({ "data-testid": "hefesto-menu" }, { children: _jsx("ul", __assign({ className: "hefesto-menu" }, { children: menuOptions === null || menuOptions === void 0 ? void 0 : menuOptions.map(function (menu, index) { return (_jsx(MenuItem, { menu: menu }, index)); }) })) })));
};
var MenuItem = function (_a) {
    var menu = _a.menu;
    var hasDropdownMenu = !!menu.options && menu.options.length > 0;
    var _b = useState(false), isDropdownMenuOpen = _b[0], setIsDropdownMenuOpen = _b[1];
    var _c = useState(false), isUsingKeyboardToNavigate = _c[0], setIsUsingKeyboardToNavigate = _c[1];
    var liMenuItem = useRef(null);
    var onMenuClick = function () {
        if (hasDropdownMenu) {
            openDropdownMenu();
        }
        else {
            menu.onClick && menu.onClick();
        }
    };
    var openDropdownMenu = function () {
        var _a;
        if (hasDropdownMenu) {
            setIsDropdownMenuOpen(true);
            if (isUsingKeyboardToNavigate) {
                (_a = liMenuItem.current) === null || _a === void 0 ? void 0 : _a.blur();
            }
        }
    };
    var closeDropdownMenu = function () {
        var _a;
        setIsDropdownMenuOpen(false);
        if (isUsingKeyboardToNavigate) {
            (_a = liMenuItem.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    var focusOnNextMenuItem = function () {
        var _a;
        var nextElementSibling = (_a = liMenuItem.current) === null || _a === void 0 ? void 0 : _a.nextElementSibling;
        if (nextElementSibling) {
            nextElementSibling.focus();
        }
    };
    var focusOnPreviousMenuItem = function () {
        var _a;
        var previousElementSibling = (_a = liMenuItem.current) === null || _a === void 0 ? void 0 : _a.previousElementSibling;
        if (previousElementSibling) {
            previousElementSibling.focus();
        }
    };
    var getLiMenuItemClassName = function () {
        var classList = ['hefesto-menu-item'];
        if (menu.active) {
            classList.push('hefesto-menu-item--active');
        }
        if (isDropdownMenuOpen) {
            classList.push('hefesto-menu-item--open');
        }
        return classList.join(' ');
    };
    var liMenuItemClassName = getLiMenuItemClassName();
    var getIconClassName = function () {
        var classList = ['hefesto-menu-item__content__icon'];
        if (isDropdownMenuOpen) {
            classList.push('icon-open');
        }
        return classList.join(' ');
    };
    var iconClassName = getIconClassName();
    var onKeyDown = function (event) {
        if (!Object.values(EMappepMenuEventCodes).find(function (code) { return code === event.code; })) {
            return;
        }
        event.preventDefault();
        if (!isUsingKeyboardToNavigate) {
            setIsUsingKeyboardToNavigate(true);
        }
        switch (event.code) {
            case EMappepMenuEventCodes.ARROW_DOWN: {
                openDropdownMenu();
                return;
            }
            case EMappepMenuEventCodes.ARROW_RIGHT: {
                focusOnNextMenuItem();
                return;
            }
            case EMappepMenuEventCodes.ARROW_LEFT: {
                focusOnPreviousMenuItem();
                return;
            }
            case EMappepMenuEventCodes.ENTER: {
                if (hasDropdownMenu) {
                    isDropdownMenuOpen ? closeDropdownMenu() : openDropdownMenu();
                }
                else {
                    !!menu.onClick && menu.onClick();
                }
                return;
            }
            case EMappepMenuEventCodes.ESC: {
                return;
            }
            default: {
                return;
            }
        }
    };
    return (_jsx("li", __assign({ className: liMenuItemClassName, ref: liMenuItem, onClick: onMenuClick, onMouseEnter: function () {
            if (isUsingKeyboardToNavigate) {
                setIsUsingKeyboardToNavigate(false);
            }
            openDropdownMenu();
        }, onMouseLeave: function () {
            if (isUsingKeyboardToNavigate) {
                setIsUsingKeyboardToNavigate(false);
            }
            closeDropdownMenu();
        }, onKeyDown: onKeyDown, tabIndex: 0 }, { children: _jsxs("div", __assign({ className: "hefesto-menu-item__content" }, { children: [_jsx("span", __assign({ className: "hefesto-menu-item__content__title" }, { children: menu.title })), hasDropdownMenu && (_jsxs(_Fragment, { children: [_jsx("i", __assign({ className: iconClassName }, { children: _jsx(Icon, { option: "CaretDown", variant: "tertiary" }) })), isDropdownMenuOpen && (_jsx(DropdownMenu, { options: menu.options || [], closeDropdownMenu: closeDropdownMenu, isUsingKeyboardToNavigate: isUsingKeyboardToNavigate, setIsUsingKeyboardToNavigate: setIsUsingKeyboardToNavigate }))] }))] })) })));
};
export default Menu;
